"use strict";

var _interopRequireWildcard = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("E:\\WebProject\\\u684C\u9762\\JY-SSO\\node_modules\\core-js\\modules\\es6.array.iterator.js");
require("E:\\WebProject\\\u684C\u9762\\JY-SSO\\node_modules\\core-js\\modules\\es6.promise.js");
require("E:\\WebProject\\\u684C\u9762\\JY-SSO\\node_modules\\core-js\\modules\\es6.object.assign.js");
require("E:\\WebProject\\\u684C\u9762\\JY-SSO\\node_modules\\core-js\\modules\\es7.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
require("normalize.css/normalize.css");
var _elementUi = _interopRequireDefault(require("element-ui"));
require("./styles/element-variables.scss");
var _vuescroll = _interopRequireDefault(require("vuescroll"));
require("vuescroll/dist/vuescroll.css");
require("@/styles/index.scss");
var _App = _interopRequireDefault(require("./App"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
var _lang = _interopRequireDefault(require("./lang"));
require("./icons");
require("./permission");
var filters = _interopRequireWildcard(require("./filters"));
// a modern alternative to CSS resets

// global css

// internationalization
// icon
// permission control

// global filters

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
// import { mockXHR } from '../mock'
// if (process.env.NODE_ENV === 'development') {
//   mockXHR()
// }
_vue.default.use(_elementUi.default, {
  size: _jsCookie.default.get('size') || 'mini',
  // set element-ui default size
  i18n: function i18n(key, value) {
    return _lang.default.t(key, value);
  }
});

// 滚动条
_vue.default.use(_vuescroll.default, {
  ops: {
    vuescroll: {
      detectResize: true
    },
    bar: {
      background: '#515a6e',
      opacity: 0.3,
      keepShow: true
    },
    scrollPanel: {
      scrollingX: false
    }
  }
});
// register global utility filters
Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});
_vue.default.config.productionTip = false;
new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  i18n: _lang.default,
  render: function render(h) {
    return h(_App.default);
  }
});